import { render, staticRenderFns } from "./CampaignItemContent.vue?vue&type=template&id=2b3659b9&scoped=true&"
import script from "./CampaignItemContent.vue?vue&type=script&lang=ts&"
export * from "./CampaignItemContent.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignItemContent.vue?vue&type=style&index=0&id=2b3659b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3659b9",
  null
  
)

export default component.exports